import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VendorOrder } from '@models/vendor-order';
import { FormatData } from '@classes/format-data';
import { sortLogsByDateDesc } from '@v2/shared/utils';

@Component({
  selector: 'app-invoice-log',
  templateUrl: './invoice-log.component.html',
  styleUrls: ['./invoice-log.component.scss'],
})
export class InvoiceLogComponent {
  @Input() order: VendorOrder;
  @ViewChild('logDetail') logModal: TemplateRef<any>;

  constructor(private dialog: MatDialog) {}

  get sortedLogs() {
    return sortLogsByDateDesc(this.order?.log);
  }

  vieOrderLog() {
    this.dialog.open(this.logModal, {
      panelClass: 'minimal',
    });
  }

  formatLogItem(item?: string): string {
    return FormatData.formatLogItem(item);
  }
}
